import styles from './NewComponents.module.scss';
import useTab from "@hooks/useTab";
import { Logo, LogoSize } from "@components/new/Logo";
import { MarketplaceStoreGroup } from "@components/new/MarketplaceStoreGroup";
import { Marketplace } from "@components/new/Marketplace";
import { Store } from "@components/new/Store";
import TextInput from "@components/TextInput/TextInput";
import DigitInput from '@components/DigitInput';
import DateRangeInput from '@components/new/DateRangeInput';
import DateInput from '@components/new/DateInput';
import { Badge, BadgeType, BadgeGroup } from "@components/new/Badge";
import { Button, ButtonSize, ButtonType } from "@components/new/Button";
import { IconButton, IconButtonSize, IconButtonType } from "@components/new/IconButton";
import { LinkButton, LinkButtonSize } from "@components/new/LinkButton";
import { Alert, AlertType } from "@components/new/Alert";
import { Tag } from "@components/new/Tag";
import { TabsList, TabsContent } from "@components/new/Tabs/Tabs";
import Switch from "@components/new/Switch";
import Checkbox from "@components/new/Checkbox";
import Radio from "@components/new/Radio";
import Skeleton from "@components/new/Skeleton";
import { H1, H2, H3, H4, P1, P2, P3, Title1, Title2, Title3, SubTitle1, SubTitle2, SubTitle3, Label } from "@components/new/Typo";
import ArmchairIcon from '@assets/icons/outline/armchair.svg?react';
import InfoIcon from '@assets/icons/info-grey-18.svg';
import { Tooltip } from '@components/new/Tooltip';

import { useState } from "react";

const NewComponents = () => {
  const [switchChecked, setSwitchChecked] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [radioChecked, setRadioChecked] = useState(false);

  const tabs = [
    {
      id: "tab-1",
      icon: ArmchairIcon,
      title: "Tab 1",
      description: "Some description",
      content: (
        <div>Tab1 content</div>
      ),
      count: 33
    },
    {
      id: "tab-2",
      icon: ArmchairIcon,
      title: "Tab 2",
      content: (
        <div>Tab2 content</div>
      ),
      // count: 99
    },
    {
      id: "tab-3",
      title: "Tab 3",
      content: (
        <div>Tab3 content</div>
      ),
      count: 999
    },
  ]
  const { activeTab, setActiveTab } = useTab(tabs);

  const disabledBefore = new Date();
  const disabledAfter = new Date();
  disabledBefore.setDate(disabledBefore.getDate() - 2);
  disabledAfter.setDate(disabledAfter.getDate() + 2);

  return (
    <div className={styles.root}>
      <div className={styles.section}>
        <h1>Logo</h1>
        <div className={styles.sectionContent}>
          <div><Logo size={LogoSize.L} /> <div>Size Large</div></div>
          <div><Logo size={LogoSize.M} /> <div>Size Medium</div></div>
          <div><Logo size={LogoSize.S} /> <div>Size Small</div></div>
        </div>
      </div>

      <div className={styles.section}>
        <h1>Buttons</h1>
        <div className={styles.buttons}>
          {Object.values(ButtonType).map(t => (
            <>
              <h2>Buttons {t}</h2>
              {Object.values(ButtonSize).map(s => (
                <div className={styles.buttonsRow}>
                  <div>size {s}</div>
                  <div className={styles.buttonsRow}>
                    <Button
                      size={s}
                      type={t}
                      title={"Button"}
                    />
                    <Button
                      size={s}
                      type={t}
                      title={"Button"}
                      loading
                    />
                    <Button
                      size={s}
                      type={t}
                      title={"Button"}
                      disabled
                    />
                  </div>
                  <div className={styles.buttonsRow}>
                    <Button
                      size={s}
                      type={t}
                      title={"Button"}
                      icon={ArmchairIcon}
                    />
                    <Button
                      size={s}
                      type={t}
                      title={"Button"}
                      icon={ArmchairIcon}
                      loading
                    />
                    <Button
                      size={s}
                      type={t}
                      title={"Button"}
                      icon={ArmchairIcon}
                      disabled
                    />
                  </div>
                </div>
              ))}
            </>
          ))}

        </div>
      </div>

      <div className={styles.section}>
        <h1>Icon Buttons</h1>
        <div className={styles.buttons}>
          {Object.values(IconButtonType).map(t => (
            <>
              <h2>Icon Buttons {t}</h2>
              {Object.values(IconButtonSize).map(s => (
                <div className={styles.buttonsRow}>
                  <div>size {s}</div>
                  <IconButton
                    size={s}
                    type={t}
                    icon={ArmchairIcon}
                  />
                  <IconButton
                    size={s}
                    type={t}
                    icon={ArmchairIcon}
                    loading
                  />
                  <IconButton
                    size={s}
                    type={t}
                    icon={ArmchairIcon}
                    disabled
                  />
                </div>
              ))}
            </>
          ))}
        </div>

        <div className={styles.section}>
          <h1>Buttons</h1>
          <div className={styles.buttons}>
            {Object.values(LinkButtonSize).map(s => (
              <div className={styles.buttonsRow}>
                <div>size {s}</div>
                <LinkButton
                  size={s}
                  title={"Link Button"}
                />
                <LinkButton
                  size={s}
                  title={"Link Button"}
                  disabled
                />
                <LinkButton
                  icon={ArmchairIcon}
                  size={s}
                  title={"Link Button"}
                />
                <LinkButton
                  icon={ArmchairIcon}
                  size={s}
                  title={"Link Button"}
                  disabled
                />
              </div>
            ))}
          </div>
        </div>

        <div className={styles.section}>
          <h1>Switch</h1>
          <div className={styles.buttons}>
            <div className={styles.buttonsRow}>
              <Switch
                checked={switchChecked}
                onChange={() => setSwitchChecked(!switchChecked)}
                title={"Switch"}
              />
              <Switch
                checked={!switchChecked}
                onChange={() => setSwitchChecked(!switchChecked)}
                title={"Switch"}
              />
              <Switch
                checked
                onChange={() => {}}
                title={"Switch"}
                disabled
              />
              <Switch
                checked={false}
                onChange={() => {}}
                title={"Switch"}
                disabled
              />
              <Switch
                checked={switchChecked}
                onChange={() => setSwitchChecked(!switchChecked)}
                title={"Switch"}
                titleOnLeft
              />
              <Switch
                checked={!switchChecked}
                onChange={() => setSwitchChecked(!switchChecked)}
                title={"Switch"}
                disabled
                titleOnLeft
              />
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h1>Checkbox</h1>
          <div className={styles.buttons}>
            <div className={styles.buttonsRow}>
              <Checkbox
                checked={checkboxChecked}
                onChange={(v) => setCheckboxChecked(v)}
              />

              <Checkbox
                checked={checkboxChecked}
                onChange={(v) => setCheckboxChecked(v)}
                error
              />

              <Checkbox
                checked
                onChange={() => {}}
              />
              <Checkbox
                checked="partial"
                onChange={() => {}}
              />
              <Checkbox
                checked={false}
                onChange={() => {}}
              />

              <Checkbox
                checked
                onChange={() => {}}
                disabled
              />
              <Checkbox
                checked="partial"
                onChange={() => {}}
                disabled
              />
              <Checkbox
                checked={false}
                onChange={() => {}}
                disabled
              />
            </div>

            <div className={styles.buttonsRow}>
              <Checkbox
                checked={checkboxChecked}
                onChange={(v) => setCheckboxChecked(v)}
                title="Checkbox"
              />

              <Checkbox
                checked={checkboxChecked}
                onChange={(v) => setCheckboxChecked(v)}
                title="Checkbox"
                error
              />

              <Checkbox
                checked={false}
                onChange={() => {}}
                title="Checkbox"
                disabled
              />
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h1>Radio</h1>
          <div className={styles.buttons}>
            <div className={styles.buttonsRow}>
              <Radio
                checked={radioChecked}
                onChange={(v) => setRadioChecked(v)}
              />

              <Radio
                checked={!radioChecked}
                onChange={(v) => setRadioChecked(!v)}
                error
              />

              <Radio checked />
              <Radio checked={false} />

              <Radio checked disabled />
              <Radio checked={false} disabled />

              <Radio checked error />
              <Radio checked={false} error />
            </div>

            <div className={styles.buttonsRow}>
              <div className={styles.column}>
                <Radio
                  checked
                  title="Radio"
                />
                <Radio
                  checked={false}
                  title="Radio"
                />
                <Radio
                  checked
                  title="Radio"
                  disabled
                />
              </div>

              <div className={styles.column}>
                <Radio
                  checked
                  title="Radio"
                  isBlock
                  description="With description"
                />
                <Radio
                  checked={false}
                  title="Radio"
                  isBlock
                  description="With description"
                />
                <Radio
                  checked
                  title="Radio"
                  disabled
                  isBlock
                  description="With description"
                />
              </div>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h1>Typography</h1>
          <div className={styles.buttons}>
            <H1>H1 example</H1>
            <H2>H2 example</H2>
            <H3>H3 example</H3>
            <H4>H4 example</H4>
            <P1>P1 example</P1>
            <P2>P2 example</P2>
            <P3>P3 example</P3>
            <Title1>Title1 example</Title1>
            <Title2>Title2 example</Title2>
            <Title3>Title3 example</Title3>
            <SubTitle1>SubTitle1 example</SubTitle1>
            <SubTitle2>SubTitle2 example</SubTitle2>
            <SubTitle3>SubTitle3 example</SubTitle3>
            <Label>Label example</Label>

            <Label color="error">Label example - error color</Label>
            <Label ellipsis width={200}>Label example - ellipsis: qwwerty qwwerty qwwerty qwwerty</Label>
            <Label ellipsis lines={2} width={120}>Label example - ellipsis 2 line: qwwerty qwwerty qwwerty qwwerty</Label>

          </div>
        </div>

        <div className={styles.section}>
          <h1>Skeleton</h1>
          <div className={styles.skeleton}>
            <Skeleton width="200px" height="24px" />
            <Skeleton width="200px" />
            <Skeleton short />

          </div>
        </div>

        <div className={styles.section}>
          <h1>Tabs</h1>
          <div className={styles.buttons}>
            <div className={styles.tabs}>
              <TabsList
                tabs={tabs}
                onChange={setActiveTab}
                value={activeTab}
              />

              <TabsContent
                tab={tabs.find((tab) => (tab.id === activeTab))}
              />
            </div>

            <div className={styles.tabs}>
              <TabsList
                tabs={tabs}
                onChange={setActiveTab}
                value={activeTab}
                vertical
              />
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <h1>Tooltip</h1>
          <div className={styles.buttons} style={{ marginLeft: "120px" }}>
            <Tooltip
              action={
                <img
                  className={styles.icon}
                  alt="Info"
                  src={InfoIcon}
                />
              }
              position="top"
              // left={9}
              text={
                <div>
                  some tooltip top
                </div>
              }
            />

            <Tooltip
              action={
                <img
                  className={styles.icon}
                  alt="Info"
                  src={InfoIcon}
                />
              }
              position="top"
              align="start"
              text={
                <div>
                  some tooltip top start
                </div>
              }
            />

            <Tooltip
              action={
                <img
                  className={styles.icon}
                  alt="Info"
                  src={InfoIcon}
                />
              }
              position="top"
              align="end"
              text={
                <div>
                  some tooltip top end
                </div>
              }
            />

            <Tooltip
              action={
                <img
                  className={styles.icon}
                  alt="Info"
                  src={InfoIcon}
                />
              }
              position="bottom"
              // left={9}
              text={
                <div>
                  some tooltip bottom
                </div>
              }
            />

            <Tooltip
              action={
                <img
                  className={styles.icon}
                  alt="Info"
                  src={InfoIcon}
                />
              }
              position="left"
              // left={9}
              text={
                <div>
                  some tooltip left
                </div>
              }
            />

            <Tooltip
              action={
                <img
                  className={styles.icon}
                  alt="Info"
                  src={InfoIcon}
                />
              }
              position="right"
              // left={9}
              text={
                <div>
                  some tooltip
                </div>
              }
            />
          </div>
        </div>

        <div className={styles.section}>
          <h1>Badge</h1>
          <div className={styles.buttons}>
            <BadgeGroup vertical>
              <Badge>badge primary</Badge>
              <Badge type={BadgeType.SECONDARY}>badge secondary</Badge>
              <Badge type={BadgeType.OUTLINE}>badge outline</Badge>
              <Badge type={BadgeType.DESTRUCTIVE}>badge destructive</Badge>
            </BadgeGroup>
            <BadgeGroup vertical>
              <Badge rounded>badge primary</Badge>
              <Badge type={BadgeType.SECONDARY} rounded>badge secondary</Badge>
              <Badge type={BadgeType.OUTLINE} rounded>badge outline</Badge>
              <Badge type={BadgeType.DESTRUCTIVE} rounded>badge destructive</Badge>
            </BadgeGroup>
          </div>
          <div className={styles.buttons}>
            <BadgeGroup>
              <Badge asChild>
                <a href="#">link</a>
              </Badge>
              <Badge type={BadgeType.SECONDARY} asChild>
                <a href="#">link secondary</a>
              </Badge>
              <Badge type={BadgeType.OUTLINE} asChild>
                <a href="#">link outline</a>
              </Badge>
              <Badge type={BadgeType.DESTRUCTIVE} asChild>
                <a href="#">link destructive</a>
              </Badge>
            </BadgeGroup>
          </div>
        </div>

        <div className={styles.section}>
          <h1>Tags</h1>
          <div className={styles.buttons}>
            <Tag value={5} />
            <Tag value={55} />
            <Tag value={555} />
            <Tag value={55} active />
            <Tag value={55} disabled />
          </div>
        </div>

        <div className={styles.section}>
          <h1>MP and Store</h1>
          <div className={styles.buttons}>
            <Marketplace name="Ozon" />
            <Marketplace name="Yandex" />
            <Marketplace name="Wildberries" />
            <Marketplace name="Aliexpress" />
            <Marketplace name="Ozon" size="small" />
            <Marketplace name="Yandex" size="small" />
            <Marketplace name="Wildberries" size="small" />
            <Marketplace name="Aliexpress" size="small" />
            <Store id="123" name="Some store" />
            <Store id="456" name="qwerty" size="small" />

            <MarketplaceStoreGroup>
              <Store id="123" name="Some store" />
              <Marketplace name="Ozon" />
            </MarketplaceStoreGroup>

            <MarketplaceStoreGroup size="small">
              <Store id="123" name="Some store" size="small" />
              <Marketplace name="Ozon" size="small" />
            </MarketplaceStoreGroup>

            <MarketplaceStoreGroup>
              <Store id="1" name="Store 1" />
              <Store id="2" name="Store 2" />
              <Store id="3" name="Store 3" />
              <Store id="4" name="Store 4" />
            </MarketplaceStoreGroup>
          </div>
        </div>

        <div className={styles.section}>
          <h1>Alerts</h1>
          <div className={styles.buttons}>
            <Alert
              type={AlertType.NEUTRAL}
              title="Alert neutral"
              description="Some description"
              button={{
                title: "button",
                onClick: () => {},
              }}
            />
            <Alert
              type={AlertType.SUCCESS}
              title="Alert success"
              description="Some description"
              button={{
                title: "button",
                onClick: () => {},
              }}
            />
            <Alert
              type={AlertType.WARNING}
              title="Alert warning"
              description="Some description"
              button={{
                title: "button",
                onClick: () => {},
              }}
            />
            <Alert
              type={AlertType.ERROR}
              title="Alert error"
              description="Some description"
              button={{
                title: "button",
                onClick: () => {},
              }}
            />
            <Alert
              type={AlertType.NEUTRAL}
              title="Alert neutral - no description"
              description=""
              button={{
                title: "button",
                onClick: () => {},
              }}
            />
            <Alert
              type={AlertType.NEUTRAL}
              title="Alert neutral - no button"
              description="Some description"
            />
            <Alert
              type={AlertType.NEUTRAL}
              title="Alert neutral - no button"
            />
          </div>
        </div>

        <div className={styles.section}>
          <h1>Input</h1>
          <div className={styles.inputColumn}>
            <TextInput
              title="Text, empty"
              type="text"
            />
            <TextInput
              title="Text"
              type="text"
              value="value"
            />
            <TextInput
              title="Text, empty with button"
              type="text"
              button={{
                title: "Button name",
                onClick: () => {},
              }}
            />
            <TextInput
              title="Text, placeholder"
              type="text"
              placeholder="placeholder"
            />
            <TextInput
              title="Text, description"
              type="text"
              description="Some description"
            />
            <TextInput
              title="Text, disabled"
              type="text"
              description="Some description"
              disabled
            />
            <TextInput
              title="Text, description, button"
              type="text"
              description="Some description"
              button={{
                title: "Button name",
                onClick: () => {},
              }}
            />
            <TextInput
              title="Text, description, link"
              type="text"
              description="Some description"
              button={{
                title: "Button name",
                to: "#",
              }}
            />
            <TextInput
              title="Text, error with message"
              type="text"
              description="Some description"
              hasError
              errorMessage="Error message"
            />
            <TextInput
              title="password"
              type="password"
            />
            <TextInput
              title="phone"
              type="phone"
              description="some description"
            />
            <TextInput
              title="Phone, russia only"
              type="phone"
              description="some description"
              onlyCountry="RU"
            />
          </div>
        </div>

        <div className={styles.section}>
          <h1>Input</h1>
          <div className={styles.buttons}>
            <DigitInput
              hasError
              length={4}
              onChange={() => {}}
              value={"12"}
            />
            <DigitInput
              disabled
              length={4}
              onChange={() => {}}
              value={"12"}
            />
            <DigitInput
              length={4}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className={styles.section}>
          <h1>Date Range Input</h1>
          <div className={styles.buttons}>
            <DateRangeInput
              onChange={() => {}}
              value={[null, null]}
            />
          </div>
        </div>

        <div className={styles.section}>
          <h1>Single Input</h1>
          <div className={styles.buttons}>
            <DateInput
              onChange={() => {}}
              value={undefined}
              disabledBefore={disabledBefore}
              disabledAfter={disabledAfter}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewComponents;
